import {
	FETCH_EXCHANGE_RATES_BEGIN,
	FETCH_EXCHANGE_RATES_SUCCESS,
	FETCH_EXCHANGE_RATES_FAILURE,
} from '../actions/fetchExchangeRates'

import merge from 'lodash/merge'

const initialState = {
	exchangeRates: [],
	loading: false,
	error: null,
}

export default function fetchExchangeRatesReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_EXCHANGE_RATES_BEGIN:
			// Request begin: set loading true
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_EXCHANGE_RATES_SUCCESS:
			// Request success: set loading false, set hotelInfo data
			return {
				...state,
				loading: false,
				error: null,
				exchangeRates: merge({}, state.exchangeRates, action.payload)
			}

		case FETCH_EXCHANGE_RATES_FAILURE:
			// Request failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				exchangeRates: [],
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchExchangeRatesReducers.js